export interface ProxyResponse {
  messageCode: string;
  success: boolean;
}

export const EMPTY_PROXY_RESPONSE: ProxyResponse = {
  messageCode: '',
  success: false,
};
